import BaseURL, { baseURL } from '../../components/helper/axiosHelper';

// Action Types
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_EMIRATES = 'SET_EMIRATES';
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';
export const SET_DATA = 'SET_DATA';
export const SET_PROFFESSSION_LIST = 'SET_PROFFESSSION_LIST';
export const SET_GETSUITABLE_TIME_LIST = 'SET_GETSUITABLE_TIME_LIST';
export const SET_GETWORK_TYPE_LIST = 'SET_GETWORK_TYPE_LIST';
export const SET_VOlLUNTEER_AP_EVENTT_View_DATA = 'SET_VOlLUNTEER_AP_EVENTT_View_DATA';
export const SET_VOlLUNTEER_EVENT_DATA = 'SET_VOlLUNTEER_EVENT_DATA';
// Actions Types URLS
export const UPDATE_FORM_DATA = `${BaseURL}/Volunteer/UpdateEPVolunteerReg`;
export const POST_FORM_DATA = `${baseURL}/Volunteer/CreateEPVolunteerReg`;
export const POST_SET_GETSUITABLE_TIME_LIST = `${BaseURL}/Utilities/GetSuitableTimeListAsync`;
export const POST_SET_PROFFESSSION_LIST = `${BaseURL}/Utilities/GetSettingsProfessionList`;
export const POST_SET_GETWORK_TYPE_LIST = `${BaseURL}/Utilities/GetWorkTypeList`;
export const GET_COUNTRY_LIST = `${BaseURL}/Utilities/GetCountryList`;
export const GET_EMIRATES_LIST = `${BaseURL}/Utilities/GetEmiratesList`;
export const POST_EVENT_REGISTER_FORM_DATA = `${baseURL}/Volunteer/CreateEPVolunteerEvent`;
export const GET_VOlLUNTEER_AP_EVENTT_View = `${baseURL}/Volunteer/GetEPVolunteerEventById`;
export const PUT_VOlLUNTEER_AP_EVENT = `${baseURL}/Volunteer/UpdateEPVolunteerEvent`;
export const GET_VOLT_EVENT_SELECTION_DATA = `${BaseURL}/Volunteer/GetEPVolunteerEventByUserId`;

// Initial state
export const initialState = {
  eventSelecton: [],
  data: [],
  countries: [],
  emirates: [],
  professionList: [],
  getSuitableTimeList: [],
  getWorkTypeList: [],
  selectedCountry: 0,
  apEventOBJ: {
    volunteerEventID: 0,
    eventNameAr: '',
    eventArabic: '',
    descAr: '',
    eventNameEn: '',
    descEn: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    volunteerNumber: 0,
    days: '',
    date: '',
    timeNow: '',
    activeID: 0,
    userID: 0,
    fileName: '',
    doc: '',
    fileType: '',
    size: ''
  }
};

// Reducer function
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTRIES:
      return { ...state, countries: action.payload };
    case SET_EMIRATES:
      return { ...state, emirates: action.payload };
    case SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: action.payload };
    case SET_DATA:
      return { ...state, data: action.payload };
    case SET_PROFFESSSION_LIST:
      return { ...state, professionList: action.payload };
    case SET_GETSUITABLE_TIME_LIST:
      return { ...state, getSuitableTimeList: action.payload };
    case SET_GETWORK_TYPE_LIST:
      return { ...state, getWorkTypeList: action.payload };
    case SET_VOlLUNTEER_AP_EVENTT_View_DATA:
      return { ...state, apEventOBJ: action.payload };
    case SET_VOlLUNTEER_EVENT_DATA:
      return { ...state, eventSelecton: action.payload };

    default:
      return state;
  }
};
